import Content from './content-container';
export default Content;


// WEBPACK FOOTER //
// ./src/component/content/index.js